import { Breadcrumbs, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate, useLocation } from 'react-router';
import { paths } from 'src/common/config/TextMessage';
import { useMemo } from 'react';
import { localSeoTexts } from 'src/content/localSeo/localSeoTexts';
import { keywordResearchDashBoardCss } from 'src/content/keywordResearch/keywordResearchCSS';
import { useCitation } from '../Providers/CitationProvider';

interface BreadcrumbConfig {
  text: string;
  path?: string;
  isActive?: boolean;
}

const citationsPaths = {
  builder: '/local-seo/citations',
  list: '/local-seo/citations/list',
  createCampaign: '/local-seo/citations/create-campaign',
  confirmAndPay: '/local-seo/citations/confirm-and-pay',
  campaignInProgress: '/local-seo/citations/campaign-in-progress',
  campaignReport: '/local-seo/citations/report'
};

export const CitationBreadcrumbs = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { getCampaignId, getBLLocationId } = useCitation();

  const getBreadcrumbs = (pathname: string): BreadcrumbConfig[] => {
    const cleanedPathname =
      pathname.endsWith('/') && pathname.length > 1
        ? pathname.slice(0, -1)
        : pathname;

    switch (cleanedPathname) {
      case citationsPaths.builder:
        return [
          {
            text: localSeoTexts.localSeo,
            path: paths.otherTools
          },
          {
            text: 'Citation Builder',
            path: citationsPaths.builder,
            isActive: true
          }
        ];

      // case CitationScreen.SCANNING:
      //   return [
      //     {
      //       text: localSeoTexts.localSeo,
      //       path: paths.otherTools
      //     },
      //     {
      //       text: localSeoTexts.citationBuilder,
      //       screen: CitationScreen.BUILDER
      //     },
      //     {
      //       text: 'Scanning',
      //       screen: CitationScreen.SCANNING,
      //       isActive: true
      //     }
      //   ];

      case citationsPaths.createCampaign:
        return [
          {
            text: localSeoTexts.localSeo,
            path: paths.otherTools
          },
          {
            text: 'Citation Builder',
            path: citationsPaths.builder
          },
          {
            text: 'Create a Campaign',
            path: citationsPaths.createCampaign,
            isActive: true
          }
        ];

      case citationsPaths.confirmAndPay:
        return [
          {
            text: localSeoTexts.localSeo,
            path: paths.otherTools
          },
          {
            text: 'Citation Builder',
            path: citationsPaths.builder
          },
          {
            text: 'Create a Campaign',
            path: citationsPaths.createCampaign
          },
          {
            text: 'Confirm & Pay',
            path: citationsPaths.confirmAndPay,
            isActive: true
          }
        ];

      case citationsPaths.campaignInProgress:
        return [
          {
            text: localSeoTexts.localSeo,
            path: paths.otherTools
          },
          {
            text: 'Citation Builder',
            path: citationsPaths.builder
          },
          {
            text: 'Campaign In Progress',
            path: citationsPaths.campaignInProgress,
            isActive: true
          }
        ];
      case citationsPaths.campaignReport:
        return [
          {
            text: localSeoTexts.localSeo,
            path: paths.otherTools
          },
          {
            text: 'Citation Builder',
            path: citationsPaths.builder
          },
          {
            text: 'Campaign Completed',
            path: citationsPaths.campaignInProgress
          },
          {
            text: 'Report',
            path: "",
            isActive: true
          }
        ];
      case citationsPaths.list:
        return [
          {
            text: localSeoTexts.localSeo,
            path: paths.otherTools
          },
          {
            text: 'Citation Builder',
            path: citationsPaths.builder
          },
          {
            text: 'All Campaigns',
            path: citationsPaths.list,
            isActive: true
          }
        ];

      default:
        return [
          {
            text: localSeoTexts.localSeo,
            path: paths.otherTools
          },
          {
            text: localSeoTexts.citationBuilder,
            isActive: true
          }
        ];
    }
  };

  const breadcrumbs = useMemo(() => getBreadcrumbs(pathname), [pathname]);

  const breadcrumbElements = breadcrumbs.map((crumb, index) => {
    const isLast = index === breadcrumbs.length - 1;
    const isActive = crumb.isActive !== undefined ? crumb.isActive : isLast;

    const handleClick = () => {
      if (crumb.path) {

        navigate(crumb.path, { state: { campaignId: getCampaignId(), locationId: getBLLocationId() } });
      }
    };

    return (
      <Typography
        key={index}
        sx={{
          ...(isActive
            ? keywordResearchDashBoardCss?.breadCrumbText
            : keywordResearchDashBoardCss?.breadCrumbLightText),
          ...(!isActive && { cursor: 'pointer' })
        }}
        onClick={!isActive ? handleClick : undefined}
      >
        {crumb.text}
      </Typography>
    );
  });

  return (
    <Breadcrumbs
      separator={
        <NavigateNextIcon
          fontSize="small"
          sx={keywordResearchDashBoardCss?.navigateNextIcon}
        />
      }
      aria-label="breadcrumb"
    >
      {breadcrumbElements}
    </Breadcrumbs>
  );
};
